import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMapPin, FiPhone, FiMail, FiX, FiSend } from "react-icons/fi";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/images/bakwenakit.png";
import "./Footer.css";

const quickLinks = [
  { label: "Bakwena Kit",     to: "/"               },
  { label: "About Us",        to: "/about"           },
  { label: "Our Services",    to: "/services"        },
  { label: "Our Projects",    to: "/projects"        },
  { label: "Project Videos",  to: "/project-videos"  },
  { label: "Our Products",        to: "/products"        },
  { label: "Contact Us",      to: "/contact"         },
];

const serviceLinks = [
  { label: "Formwork and Scaffolding",  to: "/services/framework-and-scaffolding" },
  { label: "Columns",                   to: "/services/columns"                   },
  { label: "Retaining Walls",           to: "/services/retaining-walls"           },
  { label: "Suspended Slab",            to: "/services/suspended-slab"            },
  { label: "Ring Beam",                 to: "/services/ring-beam"                 },
  { label: "Transport",                 to: "/services/transport"                 },
  { label: "Temporary Work Design",     to: "/services/temporary-work-design"     },
  { label: "PR Engineer Services",      to: "/services/pr-engineer-services"      },
];

const mapsUrl = "https://maps.google.com/?q=52+Jakaranda+Street,+Hennopspark,+Centurion,+0157";
const WHATSAPP_NUMBER = "27726234209";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [chatOpen, setChatOpen] = useState(false);
  const [chatForm, setChatForm] = useState({ fullName: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const year = new Date().getFullYear();

  const handleSubscribe = (e) => { e.preventDefault(); setEmail(""); };

  const handleChatChange = (e) => setChatForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleChatSend = (e) => {
    e.preventDefault();
    setSending(true);
    const text = encodeURIComponent(
      `*New Enquiry from Bakwena Kit Website*\n\n` +
      `*Full Name:* ${chatForm.fullName}\n` +
      `*Email:* ${chatForm.email}\n` +
      `*Phone:* ${chatForm.phone}\n\n` +
      `*Message:*\n${chatForm.message}`
    );
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    setSending(false);
    setSent(true);
    setTimeout(() => {
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");
      setChatForm({ fullName: "", email: "", phone: "", message: "" });
      setSent(false);
      setChatOpen(false);
    }, 800);
  };

  return (
    <>
      <footer className="footer">

        {/* ══════ TOP CONTACT BAR ══════ */}
        <div className="footer__topbar">
          <div className="container footer__topbar-inner">
            <Link to="/" className="footer__topbar-logo">
              <img src={logo} alt="Bakwena Kit" />
            </Link>
            <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="footer__topbar-contact">
              <div className="footer__topbar-icon"><FiMapPin size={20} /></div>
              <div>
                <span className="footer__topbar-label">Our Address</span>
                <span className="footer__topbar-value">52 Jakaranda Street, Hennopspark, Centurion, 0157</span>
              </div>
            </a>
            <a href="tel:+27120041000" className="footer__topbar-contact">
              <div className="footer__topbar-icon"><FiPhone size={20} /></div>
              <div>
                <span className="footer__topbar-label">Call Us</span>
                <span className="footer__topbar-value">012 004-1000</span>
              </div>
            </a>
            <a href="mailto:sales@bakwenakit.co.za" className="footer__topbar-contact">
              <div className="footer__topbar-icon"><FiMail size={20} /></div>
              <div>
                <span className="footer__topbar-label">Email Us</span>
                <span className="footer__topbar-value">sales@bakwenakit.co.za</span>
              </div>
            </a>
          </div>
        </div>

        {/* ══════ MAIN BODY ══════ */}
        <div className="footer__body">
          <div className="container footer__grid">

            {/* Col 1 — Brand */}
            <div className="footer__brand">
              <p className="footer__tagline">
                Bakwena Kit (Pty) Ltd it's a proudly South African formwork and scaffolding operation
                that is 100% black owned and managed. Established in 2021, Bakwena Kit is an exciting
                new affiliate company to Kit Formwork and Scaffolding, that formerly operated under the
                name RMD Kwikform (Pty) Ltd.
              </p>
              <Link to="/contact" className="footer__build-btn">
                LET'S CONSTRUCT TOGETHER
                <span className="footer__build-arrow"><FiArrowRight size={16} /></span>
              </Link>
              <div className="footer__socials">
                <a href="#" aria-label="Facebook"><FaFacebookF size={14} /></a>
                <a href="#" aria-label="Twitter"><FaTwitter size={14} /></a>
                <a href="#" aria-label="LinkedIn"><FaLinkedinIn size={14} /></a>
                <a href="#" aria-label="YouTube"><FaYoutube size={14} /></a>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="footer__socials-whatsapp"
                >
                  <FaWhatsapp size={16} />
                </a>
              </div>
            </div>

            {/* Col 2 — Quick Links */}
            <div>
              <h4 className="footer__col-heading">Quick Links</h4>
              <ul className="footer__list">
                {quickLinks.map(l => (
                  <li key={l.label}>
                    <Link to={l.to}>
                      <span className="footer__list-arrow" aria-hidden="true" />
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 3 — Services */}
            <div>
              <h4 className="footer__col-heading">Our Services</h4>
              <ul className="footer__list">
                {serviceLinks.map(l => (
                  <li key={l.label}>
                    <Link to={l.to}>
                      <span className="footer__list-arrow" aria-hidden="true" />
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Col 4 — Newsletter */}
            <div>
              <h4 className="footer__col-heading">Subscribe News</h4>
              <p className="footer__newsletter-text">Get project updates and industry insights — no spam, just value.</p>
              <form className="footer__newsletter-form" onSubmit={handleSubscribe}>
                <input
                  type="email"
                  placeholder="Your Mail*"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  className="footer__newsletter-input"
                />
                <button type="submit" className="footer__newsletter-btn" aria-label="Subscribe">
                  <FiArrowRight size={18} />
                </button>
              </form>
              <div className="footer__certs">
                {["B-BBEE L1", "ISO 45001"].map(c => <span key={c}>{c}</span>)}
              </div>
            </div>

          </div>
        </div>

        {/* ══════ BOTTOM BAR ══════ */}
        <div className="footer__bottom">
          <div className="container footer__bottom-inner">
            <p>© {year} Bakwena Kit (Pty) Ltd. All rights reserved.</p>
            <div className="footer__bottom-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Use</a>
              <a href="#">Site Map</a>
            </div>
          </div>
        </div>

      </footer>

      {/* ══════ FLOATING WHATSAPP CHAT WIDGET ══════ */}
      <div className={`wa-chat-panel${chatOpen ? " wa-chat-panel--open" : ""}`}>
        <div className="wa-chat-header">
          <div className="wa-chat-header-left">
            <div className="wa-chat-avatar"><FaWhatsapp size={22} /></div>
            <div>
              <div className="wa-chat-name">Bakwena Kit</div>
              <div className="wa-chat-status">
                <span className="wa-chat-dot" />
                Typically replies instantly
              </div>
            </div>
          </div>
          <button className="wa-chat-close" onClick={() => setChatOpen(false)} aria-label="Close chat">
            <FiX size={18} />
          </button>
        </div>
        <div className="wa-chat-body">
          <div className="wa-chat-bubble">
            <p>👋 Hi there! Fill in your details below and we'll connect with you on WhatsApp right away.</p>
          </div>
          <form className="wa-chat-form" onSubmit={handleChatSend}>
            <div className="wa-chat-field">
              <label>Full Name *</label>
              <input type="text" name="fullName" placeholder="e.g. John Dlamini" value={chatForm.fullName} onChange={handleChatChange} required />
            </div>
            <div className="wa-chat-field">
              <label>Email Address *</label>
              <input type="email" name="email" placeholder="e.g. john@example.com" value={chatForm.email} onChange={handleChatChange} required />
            </div>
            <div className="wa-chat-field">
              <label>Phone Number *</label>
              <input type="tel" name="phone" placeholder="e.g. +27 71 234 5678" value={chatForm.phone} onChange={handleChatChange} required />
            </div>
            <div className="wa-chat-field">
              <label>Message *</label>
              <textarea name="message" placeholder="What would you like to enquire about?" value={chatForm.message} onChange={handleChatChange} required rows={3} />
            </div>
            <button type="submit" className={`wa-chat-send${sent ? " wa-chat-send--sent" : ""}`} disabled={sending || sent}>
              {sent ? "Opening WhatsApp…" : (
                <>
                  <FaWhatsapp size={16} />
                  {sending ? "Sending…" : "Send via WhatsApp"}
                  {!sending && <FiSend size={14} />}
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <button
        className={`wa-fab${chatOpen ? " wa-fab--active" : ""}`}
        onClick={() => setChatOpen((prev) => !prev)}
        aria-label="Chat on WhatsApp"
      >
        {chatOpen ? <FiX size={26} /> : <FaWhatsapp size={28} />}
        {!chatOpen && <span className="wa-fab-pulse" />}
      </button>
    </>
  );
}